import AppConfig from '@/AppConfig';
import RhiFlowGuard from '@/components/RetailHealthInsurance/RhiFlowGuard';
import { HealthInsuranceContextProvider } from '@/context/HealthInsuranceContext';
import { HealthInsuranceFormsProvider } from '@/context/HealthInsuranceFormsContext';
import { useEffect } from 'react';

const BaseHealthInsurance = () => {
  useEffect(() => {
    document.title = AppConfig.RETAIL_HEALTH_INSURANCE_APP_NAME;
    return () => {
      document.title = 'Claims';
    };
  }, []);

  return (
    <HealthInsuranceContextProvider>
      <HealthInsuranceFormsProvider>
        <RhiFlowGuard />
      </HealthInsuranceFormsProvider>
    </HealthInsuranceContextProvider>
  );
};

export default BaseHealthInsurance;